import { API } from "../api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

async function j(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) {
    let d = "Erreur"; try { d = (await res.json()).detail || d; } catch (_) {}
    throw new Error(typeof d === "string" ? d : "Erreur");
  }
  return res.status === 204 ? null : res.json();
}

// Turn a stored media path/url into a displayable absolute URL
export const mediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${u.startsWith("/") ? "" : "/"}${u}`;
};

export const adminApi = {
  list: () => j("/admin/listings"),
  create: (data) => j("/admin/listings", { method: "POST", body: JSON.stringify(data) }),
  update: (slug, data) => j(`/admin/listings/${slug}`, { method: "PUT", body: JSON.stringify(data) }),
  remove: (slug) => j(`/admin/listings/${slug}`, { method: "DELETE" }),
  duplicate: (slug) => j(`/admin/listings/${slug}/duplicate`, { method: "POST" }),
  generateContent: (slug) => j(`/admin/listings/${slug}/generate-content`, { method: "POST" }),
  importUrl: (url) => j("/admin/import-url", { method: "POST", body: JSON.stringify({ url }) }),
  generateStaging: (slug, body) => j(`/admin/listings/${slug}/staging`, { method: "POST", body: JSON.stringify(body) }),
  generateFull: (slug) => j(`/admin/listings/${slug}/generate-full`, { method: "POST" }),
  generateSummary: (body) => j("/admin/generate-summary", { method: "POST", body: JSON.stringify(body) }),
  generateHighlights: (body) => j("/admin/generate-highlights", { method: "POST", body: JSON.stringify(body) }),
  generateHighlightsBatch: (body) => j("/admin/generate-highlights-batch", { method: "POST", body: JSON.stringify(body || {}) }),
  regenerateMediaBatch: (body) => j("/admin/regenerate-media-batch", { method: "POST", body: JSON.stringify(body || {}) }),
  translateAll: (body) => j("/admin/i18n/translate-all", { method: "POST", body: JSON.stringify(body || {}) }),
  translateAllStatus: () => j("/admin/i18n/translate-all/status"),
  mediaBatchStatus: () => j("/admin/media-batch-status"),
  activityImage: (body) => j("/admin/activity-image", { method: "POST", body: JSON.stringify(body) }),
  cityGalleryPreview: (body) => j("/admin/city-gallery-preview", { method: "POST", body: JSON.stringify(body || {}) }),
  deleteStaging: (slug, id) => j(`/admin/listings/${slug}/staging/${id}`, { method: "DELETE" }),
  // Soumissions propriétaires
  listSubmissions: () => j("/admin/submissions"),
  getSubmission: (id) => j(`/admin/submissions/${id}`),
  updateSubmission: (id, data) => j(`/admin/submissions/${id}`, { method: "PUT", body: JSON.stringify(data) }),
  publishSubmission: (id, ownerId) => j(`/admin/submissions/${id}/publish`, { method: "POST", body: JSON.stringify(ownerId ? { owner_id: ownerId } : {}) }),
  refuseSubmission: (id) => j(`/admin/submissions/${id}/refuse`, { method: "POST" }),
  getSettings: () => j("/admin/settings"),
  updateSettings: (data) => j("/admin/settings", { method: "PUT", body: JSON.stringify(data) }),
  // Membres / affiliations (super admin)
  listMembers: (statusF) => j(`/admin/members${statusF ? `?status_f=${statusF}` : ""}`),
  setMemberStatus: (memberId, status) => j(`/admin/members/${memberId}/status`, { method: "POST", body: JSON.stringify({ status }) }),
  updateMember: (memberId, data) => j(`/admin/members/${memberId}`, { method: "PATCH", body: JSON.stringify(data) }),
  sendPresentation: (memberId, body) => j(`/admin/members/${memberId}/send-presentation`, { method: "POST", body: JSON.stringify(body || {}) }),
  notifications: () => j("/admin/notifications"),
  pendingCount: () => j("/admin/pending-count"),
  stats: () => j("/admin/stats"),
  offersAll: () => j("/offers/admin/all"),
  roi: () => j("/admin/roi"),
  roiConfig: () => j("/admin/roi/config"),
  saveRoiConfig: (data) => j("/admin/roi/config", { method: "PUT", body: JSON.stringify(data) }),
  roiManualList: () => j("/admin/roi/manual"),
  roiManualAdd: (data) => j("/admin/roi/manual", { method: "POST", body: JSON.stringify(data) }),
  roiManualDelete: (id) => j(`/admin/roi/manual/${id}`, { method: "DELETE" }),
  // Module financier (associés)
  finOverview: () => j("/admin/finance/overview"),
  finConfig: () => j("/admin/finance/config"),
  finSaveConfig: (data) => j("/admin/finance/config", { method: "PUT", body: JSON.stringify(data) }),
  finInvestments: () => j("/admin/finance/investments"),
  finAddInvestment: (data) => j("/admin/finance/investments", { method: "POST", body: JSON.stringify(data) }),
  finDelInvestment: (id) => j(`/admin/finance/investments/${id}`, { method: "DELETE" }),
  finExpenses: () => j("/admin/finance/expenses"),
  finSaveExpense: (data) => j("/admin/finance/expenses", { method: "PUT", body: JSON.stringify(data) }),
  finMonths: () => j("/admin/finance/months"),
  finMonth: (m) => j(`/admin/finance/month/${m}`),
  finClose: (data) => j("/admin/finance/close", { method: "POST", body: JSON.stringify(data) }),
  finDistributions: () => j("/admin/finance/distributions"),
  finDelDistribution: (id) => j(`/admin/finance/distributions/${id}`, { method: "DELETE" }),
  // Supervision (Phase C)
  events: (params = "") => j(`/admin/events${params ? `?${params}` : ""}`),
  eventsUnread: () => j("/admin/events/unread-count"),
  markEventRead: (id) => j(`/admin/events/${id}/read`, { method: "POST" }),
  markAllEventsRead: () => j("/admin/events/read-all", { method: "POST" }),
  deleteEvent: (id) => j(`/admin/events/${id}`, { method: "DELETE" }),
  testEvent: (data) => j("/admin/events/test", { method: "POST", body: JSON.stringify(data || {}) }),
  emailPreviewAll: (data) => j("/admin/email-preview-all", { method: "POST", body: JSON.stringify(data || {}) }),
  upload: async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${API}/admin/upload`, { method: "POST", credentials: "include", body: fd });
    if (!res.ok) throw new Error("Échec de l'upload");
    return res.json(); // { url, path, content_type }
  },
};
